import { useState } from "react";

const SCENES = ["全部", "高能反转", "神回复现场", "直播回放", "名场面台词", "翻车记录", "氛围短片"];

const ITEMS = [
  {
    scene: "高能反转",
    type: "录屏回放",
    title: "一句话让全场安静，接着反手翻盘的名场面",
    desc: "完整录屏里最值得回看的一段，情绪急转弯，弹幕同步炸开。",
    heat: "218.4w 围观",
    comment: "1.9w 条热评",
    dur: "00:47",
    img: "https://readdy.ai/api/search-image?query=high_energy_reversal_scene_cover_art_with_dramatic_warm_red_and_amber_radial_glow_and_silhouette_burst_motion_on_a_soft_cream_background_stylized_flat_motion_graphics_no_text_minimal_modern_entertainment_thumbnail_aesthetic&width=900&height=560&seq=stream-01&orientation=landscape",
  },
  {
    scene: "神回复现场",
    type: "表情包",
    title: "评论区神回复名场面，一张图把话接住了",
    desc: "把最会接话的那条神评压成表情，回复时直接甩出去，比打字快。",
    heat: "96.3w 围观",
    comment: "7800 条热评",
    dur: "动图",
    img: "https://readdy.ai/api/search-image?query=bold_witty_comment_reaction_meme_cover_with_stack_of_speech_bubble_shapes_in_warm_orange_red_and_cream_flat_vector_style_on_minimal_background_no_readable_text_playful_high_contrast_modern_editorial_aesthetic&width=900&height=560&seq=stream-02&orientation=landscape",
  },
  {
    scene: "直播回放",
    type: "短视频",
    title: "高能名场面台词切片，节奏被重新卡准",
    desc: "完整回放太长，只留高能那一段，进戏到爆发之间的节奏刚好。",
    heat: "152.7w 围观",
    comment: "1.2w 条热评",
    dur: "00:32",
    img: "https://readdy.ai/api/search-image?query=cinematic_short_clip_cover_with_abstract_warm_ember_light_particles_and_bold_play_button_mark_on_dark_red_amber_scene_gradient_minimal_flat_art_no_readable_text_high_contrast_movie_thumbnail_aesthetic&width=900&height=560&seq=stream-03&orientation=landscape",
  },
  {
    scene: "翻车记录",
    type: "录屏回放",
    title: "全员翻车那三分钟，录屏回放原汁原味",
    desc: "实时没跟上的回放补个档，原音原画不剪情绪，节奏卡在名场面。",
    heat: "64.8w 围观",
    comment: "3100 条热评",
    dur: "03:12",
    img: "https://readdy.ai/api/search-image?query=goofy_caught_on_camera_recording_frame_abstract_stylized_with_warm_amber_spotlight_and_soft_cream_wall_background_flat_vector_motion_no_readable_text_minimal_funny_entertainment_clip_cover_aesthetic&width=900&height=560&seq=stream-04&orientation=landscape",
  },
  {
    scene: "名场面台词",
    type: "动图",
    title: "高能名场面动图，一句话反复循环不腻",
    desc: "把最炸的那句台词做成循环动图，聊天高光时刻直接甩出来。",
    heat: "178.2w 围观",
    comment: "9800 条热评",
    dur: "动图",
    img: "https://readdy.ai/api/search-image?query=looping_gif_reaction_cover_of_a_bold_abstract_word_bubble_in_warm_red_amber_cream_with_radiating_energy_rays_flat_modern_vector_no_readable_text_minimal_high_contrast_meme_aesthetic&width=900&height=560&seq=stream-05&orientation=landscape",
  },
  {
    scene: "氛围短片",
    type: "短视频",
    title: "慢下来的一段氛围短片，BGM 比人声更抢戏",
    desc: "安静下来的切片也很有料，节奏与画面卡位，适合睡前慢慢看。",
    heat: "43.1w 围观",
    comment: "1500 条热评",
    dur: "01:08",
    img: "https://readdy.ai/api/search-image?query=slow_calm_mood_clip_cover_with_warm_soft_amber_gradient_haze_and_gentle_light_rays_over_cream_abstract_shapes_flat_minimal_no_readable_text_relaxing_modern_editorial_aesthetic&width=900&height=560&seq=stream-06&orientation=landscape",
  },
];

export default function SceneStream() {
  const [active, setActive] = useState("全部");
  const shown = active === "全部" ? ITEMS : ITEMS.filter((i) => i.scene === active);

  return (
    <section id="scene" className="relative w-full bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-700">
              <i className="ri-scissors-2-line" />
              SCENE SORTED · 按场景切片
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              黑料色片段，替你切好再放上来
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              同一种情绪的动图、短视频与录屏放一起，想找黑料色动态图还是视频剪辑，
              先选一个场景，剩下的都在下面了。
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-600">
            <span className="flex h-9 items-center gap-1 rounded-md bg-background-200 px-3">
              <i className="ri-upload-cloud-2-line text-primary-600" />
              今日已入库 <strong className="text-foreground-950">312 段</strong>
            </span>
          </div>
        </div>

        {/* 场景切片的横向过滤条 */}
        <div className="mt-8 flex flex-wrap gap-2">
          {SCENES.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => setActive(s)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition ${
                active === s
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-50 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {s}
            </button>
          ))}
        </div>

        {/* 大图卡片流 */}
        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {shown.map((c) => (
            <article
              key={c.title}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:border-primary-200"
            >
              <div className="relative aspect-[900/560] w-full overflow-hidden">
                <img
                  src={c.img}
                  alt={`${c.title}切片预览`}
                  title={`${c.title} · 黑料色录屏片段`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-950/70 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  {c.type}
                </span>
                <span className="absolute right-4 top-4 rounded-md bg-background-950/70 px-2.5 py-1 text-xs tabular-nums text-background-50 backdrop-blur">
                  {c.dur}
                </span>
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-90 transition group-hover:scale-110 group-hover:bg-primary-600">
                    <i className="ri-play-fill text-2xl" />
                  </span>
                </span>
              </div>
              <div className="flex flex-col gap-3 p-5 md:p-6">
                <div className="flex items-center gap-2">
                  <span className="rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
                    {c.scene}
                  </span>
                  <span className="text-xs text-foreground-500">来自黑料色切片库</span>
                </div>
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                  {c.title}
                </h3>
                <p className="text-sm leading-6 text-foreground-600">{c.desc}</p>
                <div className="mt-1 flex flex-wrap items-center justify-between gap-2 border-t border-background-200 pt-4">
                  <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-fire-fill text-primary-600" />
                      {c.heat}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-chat-3-fill text-accent-700" />
                      {c.comment}
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <a href="#buzz" className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 transition hover:bg-background-200">
                      <i className="ri-chat-smile-2-line text-primary-600" />
                      围观评论
                    </a>
                    <a href="#howto" className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition hover:bg-primary-600">
                      收藏这段
                      <i className="ri-bookmark-line" />
                    </a>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}